var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.$currentUser.role !== "admin"
      ? _c("div", { staticClass: "main-content bg-white" }, [
          _c("span", { staticClass: "alert-danger" }, [
            _vm._v("У вас нет доступа к этой странице.")
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.$currentUser.role === "admin"
      ? _c(
          "div",
          { staticClass: "main-content bg-white" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row mb-2" }, [
              _c(
                "div",
                { staticClass: "col-sm-4 col-md-3 col-lg-3 col-xl-2" },
                [
                  _c(
                    "b-btn",
                    {
                      directives: [
                        {
                          name: "b-modal",
                          rawName: "v-b-modal.createUserGroup",
                          modifiers: { createUserGroup: true }
                        }
                      ],
                      staticClass: "mainButton filterComponent",
                      staticStyle: { "white-space": "nowrap" },
                      attrs: { size: "sm", variant: "success" }
                    },
                    [_vm._v("\n          Создать группу\n        ")]
                  )
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-12" }, [
                _vm.userGroups.length > 0
                  ? _c(
                      "div",
                      [
                        _c("b-table", {
                          attrs: {
                            hover: "",
                            responsive: "",
                            bordered: "",
                            small: "",
                            items: _vm.userGroups,
                            fields: _vm.fields,
                            "no-local-sorting": "",
                            "sort-by": _vm.sortBy,
                            "sort-desc": _vm.sortDesc,
                            "sort-direction": _vm.sortDirection
                          },
                          on: {
                            "update:sortBy": function($event) {
                              _vm.sortBy = $event
                            },
                            "update:sort-by": function($event) {
                              _vm.sortBy = $event
                            },
                            "sort-changed": _vm.getUserGroups,
                            "update:sortDesc": function($event) {
                              _vm.sortDesc = $event
                            },
                            "update:sort-desc": function($event) {
                              _vm.sortDesc = $event
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(actions)",
                                fn: function(row) {
                                  return [
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn btn-warning",
                                        attrs: { size: "sm" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.editUserGroup(row)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-edit"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-button",
                                      {
                                        staticClass: "btn btn-danger",
                                        attrs: { size: "sm" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.deleteUserGroup(row.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "icon-fa icon-fa-trash-o"
                                        })
                                      ]
                                    )
                                  ]
                                }
                              },
                              {
                                key: "cell(users)",
                                fn: function(row) {
                                  return [
                                    _vm._l(row.item.users, function(
                                      item,
                                      index
                                    ) {
                                      return _c("span", [
                                        index == row.item.users.length - 1
                                          ? _c("span", [
                                              _vm._v(_vm._s(item.name))
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        index >= 0 &&
                                        index < row.item.users.length - 1
                                          ? _c("span", [
                                              _vm._v(_vm._s(item.name) + ", ")
                                            ])
                                          : _vm._e()
                                      ])
                                    }),
                                    _vm._v(" "),
                                    row.item.users == 0 ? _c("div") : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2487559792
                          )
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "userGroupCreateModal",
                attrs: {
                  id: "createUserGroup",
                  size: "md",
                  title: "Создать группу",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideCreateModal }
              },
              [_c("CreateUserGroupModal")],
              1
            ),
            _vm._v(" "),
            _c(
              "b-modal",
              {
                ref: "userGroupEditModal",
                attrs: {
                  id: "userGroupEditModal",
                  size: "md",
                  title: "Редактировать группу",
                  "hide-footer": ""
                },
                on: { hidden: _vm.hideCreateModal }
              },
              [
                _c("EditUserGroupModal", {
                  attrs: { userGroup: _vm.selectedUserGroup }
                })
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "page-header" }, [
      _c("h3", { staticClass: "page-title" }, [_vm._v("Группы пользователей")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d381b078", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d381b078","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/front/UserGroups.vue
// module id = 1081
// module chunks = 0